var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"settled-in"}},[_c('router-link',{staticClass:"d-flex flex-wrap  justify-content-center link",attrs:{"to":{name:'enter'}}},[_c('i',{staticClass:"fa fa-font-awesome"}),_c('span',[_vm._v("入驻")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }